import { render } from "./CheckBox.vue?vue&type=template&id=1a086a1b&scoped=true&ts=true"
import script from "./CheckBox.vue?vue&type=script&lang=ts"
export * from "./CheckBox.vue?vue&type=script&lang=ts"

import "./CheckBox.vue?vue&type=style&index=0&id=1a086a1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a086a1b"]])

export default __exports__